import { Params } from '@angular/router';
import { HisArrayUtils, HisStringUtils } from '../../../core/utils';
import { HisOption } from '../his-option';
import { HisWidgetBase } from '../his-widget-base';
import { HisWidgetBaseSelect } from '../his-widget-base-select';
import { HisWidgetGroup } from '../his-widget-group';
import { HisOptionWidget } from '../his-widget-option';
import { HisWidgetUtils } from '../../utils/his-widget-utils';
import { HisSearch, HisSearchCriteria, HisSearchCriteriaGroup, HisSearchGroup } from './his-search';
import { HisSearchConstants } from './his-search-constants';
import { HisSearchItem } from './his-search-item';
import { HisSearchNonCriteriaUrlParam } from './his-search-non-criteria-url-param';
import { HisSearchParser } from './his-search-parser';

export class HisSearchParserHelper {

    public static createNewHisSearchByWidgetValues(widgetGroups: HisWidgetGroup[], configFile: string): HisSearch {
        // let logMessageId = 'his-search-parser-helper#createNewHisSearchByWidgetValues()';
        // console.log(logMessageId + '#widgetGroups', widgetGroups);
        let search = new HisSearch();
        search.configFile = configFile;
        for (let group of widgetGroups) {
            let searchGroup = new HisSearchGroup();
            searchGroup.groupLabel = group.label;
            for (let widget of group.widgets) {
                // isEmptyArray macht hier noch Prüfung auf isArray
                if ( HisWidgetUtils.isActualSelection( widget.value ) || ( widget instanceof HisWidgetBaseSelect && widget.not ) ) {
                    // console.log(logMessageId + '#widget at search form', widget);
                    let criterion = this.createNewSearchCriteria(widget, widget.id);
                    searchGroup.criteria.push(criterion);
                }
            }
            for (let criteriaGroup of group.criteriaGroups) {
                let searchCriteriaGroup = new HisSearchCriteriaGroup();
                searchCriteriaGroup.excluding = criteriaGroup.notInCriteriaGroup;

                for (let widget of criteriaGroup.widgets) {
                    // isEmptyArray macht hier noch Prüfung auf isArray
                    if ( HisWidgetUtils.isActualSelection( widget.value ) ) {
                        console.log(
                            'his-search-parser-helper#createNewHisSearchByWidgetValues()',
                            '#widget at criteria group', widget);
                        let path = widget.id.substring(widget.id.indexOf(']') + 1);
                        let criterion = this.createNewSearchCriteria(widget, path);
                        searchCriteriaGroup.criteria.push(criterion);
                    }
                }
                if (searchCriteriaGroup.criteria.length > 0) {
                    searchGroup.criteriaGroups.push(searchCriteriaGroup);
                }
            }
            if (searchGroup.criteria.length > 0 || searchGroup.criteriaGroups.length > 0) {
                search.groups.push(searchGroup);
            }
            if (searchGroup.criteriaGroups.length > 1) {
                console.log(
                    'his-search-parser-helper#createNewHisSearchByWidgetValues()',
                    '#group.combineCriteriaGroupsByOr', group.combineCriteriaGroupsByOr);
                searchGroup.criteriaGroupAnd = !group.combineCriteriaGroupsByOr;
            }
        }
        return search;
    }

    static createNewSearchCriteria(widget: HisWidgetBase<any>, key?: string): HisSearchCriteria {
        let criterion = new HisSearchCriteria();
        let path = key ? key : widget.id;
        criterion.field = path;
        console.log('his-search-parser-helper#createNewSearchCriteria() #widget', widget);

        // Checkbox
        if (widget.kind === 'checkbox') {
            let optionWidget = widget as HisOptionWidget;
            console.log('his-search-parser-helper#createNewSearchCriteria() #optionWidget.option', optionWidget.option);
            criterion.value = this.convertValueToString(path, widget.value, optionWidget.option);
            return criterion;
        }

        if (widget instanceof HisWidgetBaseSelect && widget.not) {
            criterion.not = true;
        }

        if (widget.kind === 'tree-select') {
            // widget.value ist bei trees ein Array mit Objects
            let objectArray = Object.assign([], widget.value);
            let value: string;
            for (let obj of objectArray) {
                let option = obj as ( HisOption & { subTreeSelected?: boolean } &  { lid?: string });
                console.log('his-search-parser-helper#createNewSearchCriteria() #option', option);
                // Falls das Object versioniert ist
                let val: string;
                console.log('his-search-parser-helper#createNewSearchCriteria() #path', path);
                if ((path.endsWith('.lid') || path.endsWith('Obj.id')) && option.lid) {
                    val = option.lid;
                } else {
                    val = option.id;
                }
                if ( val ) {
                    if ( option.subTreeSelected ) {
                        console.log('his-search-parser-helper#createNewSearchCriteria() #subTreeSelected', option.subTreeSelected);
                        // Indicate that all children of a tree node shall be added to the select list
                        // See also GenericSearchTask.fillSearchCriteriaFromRequestFields(..)
                        val += 'x';
                        console.log('his-search-parser-helper#createNewSearchCriteria() #val', val);
                    }
                    if (value) {
                        value += val;
                    } else {
                        value = val;
                    }
                    value += ',';
                    console.log('his-search-parser-helper#createNewSearchCriteria() #value', value);
                }
            }
            criterion.value = value;
            console.log('his-search-parser-helper#createNewSearchCriteria() #criterion #tree', criterion);
            return criterion;
        }

        criterion.value = this.convertValueToString(path, widget.value, null);
        console.log('his-search-parser-helper#createNewSearchCriteria() #criterion', criterion);
        return criterion;
    }

    public static convertUrlParamsToHisSearch(queryParams: Params): HisSearch {
        let items: HisSearchItem[] = HisSearchParserHelper.convertFlatObjectFormatParamsToHisSearchItems(queryParams);
        return HisSearchParser.decode(items);
    }

    /**
     * Konvertiert params einer Url im alten Format zu HisSearch.
     * Es wird davon ausgegangen, dass es keine Daten zu einer Gruppe gibt, wesahlb eine 'default' Gruppe abgelegt wird.
     *
     * ACHTUNG: kann nicht mit Kriteriengruppen umgehen, nur verwenden für alte URL Parameter
     */
    public static convertOldUrlParamsToHisSearch(queryParams: any, configFile: string): HisSearch {
        let search: HisSearch = new HisSearch();
        search.configFile = configFile;

        let keys = Object.keys( queryParams );
        if ( keys.length > 0 ) {
            let newGroup = new HisSearchGroup();

            // FIXME warum wird hier die Defaultgruppe gesetzt?
            newGroup.groupLabel = 'default';
            for ( let key of keys ) {
                if (this.shouldSkipParamDetection(key)) {
                    continue;
                }

                // Checkbox values sollten hier schon den value aus der Suchkofigurationsdatei haben
                let value = this.convertValueToString(key, queryParams[key], null);
                console.log(
                    'his-search-parser-helper#convertKeyValueUrlParamsToHisSearch()',
                    'key', key, '#value', value);
                if (!value) {
                    continue;
                }
                let criteria = new HisSearchCriteria();
                if (key.endsWith('(NOT)') && value === 'true') {
                    criteria.not = true;
                    continue;
                }
                criteria.field = this.normalizeKey(key);
                criteria.value = this.normalizeValue(value);
                newGroup.criteria.push(criteria);
            }
            search.groups.push(newGroup);
        }
        return search;
    }

    private static normalizeValue(value: string): string {

        if (value.includes('\"')) {
            let valueWithoutQuotes = value.replace('\"', '');
            console.log('his-search-parser-helper#normalizeValue() #replace \"', valueWithoutQuotes);
            return this.normalizeValue(valueWithoutQuotes);
        }

        if (value.includes('[')) {
            let valueWithoutOpenedSquareBracket = value.replace('[', '');
            console.log('his-search-parser-helper#normalizeValue() #replace [', valueWithoutOpenedSquareBracket);
            return this.normalizeValue(valueWithoutOpenedSquareBracket);
        }

        if (value.includes(']')) {
            let valueWithoutClosedSquareBracket = value.replace(']', '');
            console.log('his-search-parser-helper#normalizeValue() #replace ]', valueWithoutClosedSquareBracket);
            return this.normalizeValue(valueWithoutClosedSquareBracket);
        }
        return value;
    }

    private static normalizeKey(key: string): string {
        if (key.endsWith('[]')) {
            return key.replace('[]', '');
        }
        return key;
    }

    private static shouldSkipParamDetection(key: string): boolean {
        for (let nonSearchCriteria of Object.values(HisSearchNonCriteriaUrlParam) ) {
            if (key === nonSearchCriteria) {
                console.log(
                    'his-search-parser-helper#shouldSkipParamDetection()',
                    '#skipped non search criteria key', key);
                return true;
            }
        }
        return false;
    }

    public static convertHisSearchToFlatObjectFormatParams(search: HisSearch): Params {
        if (!search.configFile) {
            throw new Error('his-search-parser-helper#convertHisSearchToFlatObjectFormatParams(): no search.configFile present!');
        }
        let queryParams: Params = {};
        let searchItems: HisSearchItem[] = HisSearchParser.encode(search);
        searchItems.push(new HisSearchItem(HisSearchConstants.SEARCH_CONFIG_FILE, search.configFile));
        for (let item of searchItems) {
            queryParams[item.key] = item.value;
        }
        return queryParams;
    }

    public static convertFlatObjectFormatParamsToHisSearchItems(params: Record<string, any>): HisSearchItem[] {
        let items: HisSearchItem[] = [];
        for (let key of Object.keys(params)) {
            if (key.startsWith(HisSearchConstants.GROUPS)) {
                let item = new HisSearchItem(key, params[key]);
                items.push(item);
            }
            if (key === HisSearchConstants.SEARCH_CONFIG_FILE) {
                let item = new HisSearchItem(key, params[key]);
                items.push(item);
            }
        }
        return items;
    }

    /**
     * Value kann als String, Number, Array oder Object vorliegen
     * ACHTUNG: bei Checkboxen ist der value=true. Dafür hat eine Checkbox ein option mit dem value aus der Suchkonfiguration,
     * z. B. <>ISNULL oder 0 oder JA. Dieser Wert wird nur dann gesetzt, wenn die Checkbox ausgewählt wird, sonst nicht.
     *
     * @param key key dient nur der Log-Ausgabe
     * @param value the value to convert
     * @param checkboxValue value for the checkbox from the search configuration
     * @returns the value as string
     */
    public static convertValueToString(key: string, value: any, checkboxValue: string): string {
        // FIXME Vergleiche his-search-criteriagroup.component#widgetValueAsString

        console.log('his-search-parser-helper#convertValueToString() #key', key, '#value', value, '#checkboxValue', checkboxValue);
        if (value === null) {
            return null;
        }

        if (typeof value === 'string') {
            if (HisStringUtils.isBlank(value)) {
                // Blank string is not a valid value
                return null;
            }
            return value;
        }
        if (typeof value === 'boolean' && value === true && checkboxValue) {
            return checkboxValue;
        }

        if (Array.isArray(value)) {
            let objectArray = Object.assign([], value);
            if (objectArray.length === 0) {
                // Empty array is not a valid value
                return null;
            }

            // es ist ein Array mit Objects, also [{}, {}, etc.]
            let values = objectArray.map(obj => obj.id).join(',');
            console.log('his-search-parser-helper#convertValueToString(): object array:', key, values);
            return values;
        } else {
            // Dropdown
            console.log('his-search-parser-helper#convertValueToString(): dropdown', key, value);
            // im Fall von Dropdown ist es ein Object {label: bla, id: 4711}
            let id = 'id';
            return value[id];
        }
    }

    public static getCriterionWithPath(path: string, criteria: HisSearchCriteria[]): HisSearchCriteria {
        // console.log('his-search-parser-helper#getCriterionWithPath() #criteria', criteria);
        for (let criterion of criteria) {
            // console.log('his-search-parser-helper#getCriterionWithPath():', '#path', path);
            // console.log(
            //    'his-search-parser-helper#getCriterionWithPath():',
            //    '#criterion', criterion, 'endsWith(path)', criterion.field.endsWith(path));

            if (criterion.field.endsWith(path)) {
                // console.log('his-search-parser-helper#getCriterionWithPath() #found criterion', criterion);
                return criterion;
            }
        }
        return undefined;
    }

    /**
     * Die Default Gruppe wird angehängt, falls eine Suche ohne Suchkriterien durchgeführt wird.
     * Im Falls der Hinzunahem von Suchkriterien, z. B. durch den Filter, kommt es zu Fehlern mit der "default" Gruppe
     * Diese muss deshalb entfernt werden.
     */
    public static removeDefaultGroupFromSearchIfOtherGroupIsPresent(search: HisSearch): HisSearch {
        console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #search #1', search);
        if(search.groups.length === 0) {
            // nothing to change
            console.log(
                'his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent()' +
                '#search #search.groups.length === 0', search);
            return search;
        }
	    if (search.groups.length === 1 && search.groups[0].groupLabel === 'default') {
            // nothing to change
            console.log(
                'his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent()' +
                'search.groups.length === 1 && search.groups[0].groupLabel === default', search);
            return search;
	    }

        let remainigGroups: HisSearchGroup[] = [];
        for ( let group of search.groups) {
            console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #group', group);
            console.log(
	            'his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #group.groupLabel', group.groupLabel);
            console.log(
                'his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() group.groupLabel !== default',
                group.groupLabel !== 'default');
            if (group.groupLabel !== 'default') {
                remainigGroups.push(group);
                continue;
            }
        }
        search.groups = remainigGroups;
        console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #search #2', search);
        return search;
    }
}
